import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private readonly http = inject(HttpClient);

  public API_URL = '';
  public API_Username = '';
  public API_Password = '';

  private handleError(error: any) {
    console.error(error);
    return throwError(() => {
      const error: any = new Error(`There has been an error with the HTTP request.`);
      error.timestamp = Date.now();
      return error;
    });
  }

  get<T>(apiEndpoint: string): Observable<T> {
    return this.http.get<T>(`${this.API_URL}/${apiEndpoint}`).pipe(
      tap(data => console.log(data)),
      catchError(this.handleError)
    );
  }

  getWithParam<T>(apiEndpoint: string, param: string): Observable<T> {
    return this.http.get<T>(`${this.API_URL}/${apiEndpoint}/${param}`).pipe(
      tap(data => console.log(data)),
      catchError(this.handleError)
    );
  }

  post<T, U>(apiEndpoint: string, data: T): Observable<U> {
    const httpOptions = {
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .set('Authorization', 'Basic ' + window.btoa(this.API_Username + ':' + this.API_Password))
    };
    return this.http.post<U>(`${this.API_URL}/${apiEndpoint}`, data, httpOptions).pipe(
      tap(data => console.log(data)),
      catchError(this.handleError)
    );
  }
}
